import moment from "jalali-moment";

export const formatDate = date => {
  try{
    return date !== "--/--/----"
        ? moment(date)
            .locale("fa")
            .format("DD MMMM ، YYYY")
        :
        "--/--/----"
        ;
  }
  catch (e) {
    return  "--/--/----"
  }
};

export const getMonth = date => {
  return date !== "--/--/----"
    ? moment(date)
        .locale("fa")
        .format("MMMM")
    : moment()
        .locale("fa")
        .format("MMMM");
};

export const getYear = date => {
  return date !== "--/--/----"
    ? moment(date)
        .locale("fa")
        .format("YYYY")
    : moment()
        .locale("fa")
        .format("YYYY");
};
